import React, { useRef } from "react";
import "../../../../../styles/ComponentsStyles/Organizational/Management/Activities/PollingCard.style.css";
import PropTypes from "prop-types";
const PollingCard = ({ title, date, personName, handleCardClick }) => {
  const pollingCandidateRef = useRef();
  return (
    <button
      onClick={handleCardClick}
      className="pollingCard"
      ref={pollingCandidateRef}
    >
      <div className="pollingCardLeft">
        <h3>{title}</h3>
        <p>{date}</p>
      </div>
      <p className="pollingPersonName">{personName}</p>
    </button>
  );
};

export default PollingCard;

PollingCard.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  personName: PropTypes.string.isRequired,
};
